import { pcpGrayPalette } from "../palette"

/** By defining your own custom token in "PcpTokens" type you can pass it's value to the theme. All tokens from the type are already inserted into the theme v9 provider (the usages of <FluentProvider>).
 *  Some custom token can be replaced with token from @fulentui lib. But first you need to update the corresponding color from 'pcpComponentsLightTheme.pallete' to a custom value. Also check no inappropriate color would be misused all over other places of the live-lesson app after the replacement.
 *  Example: "pcpTokens.pcpColorNeutralStroke2" is override of "tokens.colorNeutralStroke2" from @fluentui.
 *  
 *  Some custom tokens are used for almost the same purposes as @fulentui library tokens, but a slightly different usage. The different usage may cause side effects when changing the @fulentui library token, so such a color (token) should always be defined in a separate custom token (with the 'pcp' prefix).
*/
export declare type PcpTokens = {
  pcpColorNeutralBackground1White: string,
  pcpColorNeutralBackground6Dark: string,  //value similar to "colorNeutralBackground6" in @fluentui dark theme, but used in pcp light theme.
  pcpColorNeutralStroke2: string,
  pcpColorNeutralStrokeDisabled: string,
  pcpColorNeutralBackground3: string,
  pcpButtonBorderRadius: string,
  pcpButtonFocusedBoxShadow: string,
}

/** constructing a custom tokens object */
export const pcpTokens: Record<keyof PcpTokens, string> = {
  pcpColorNeutralBackground1White: `var(--pcpColorNeutralBackground1White)`,
  pcpColorNeutralBackground6Dark: `var(--pcpColorNeutralBackground6Dark)`,
  pcpColorNeutralStroke2: `var(--pcpColorNeutralStroke2)`,
  pcpColorNeutralStrokeDisabled: `var(--pcpColorNeutralStrokeDisabled)`,
  pcpColorNeutralBackground3: `var(--pcpColorNeutralBackground3)`,
  pcpButtonBorderRadius: `var(--pcpButtonBorderRadius)`,
  pcpButtonFocusedBoxShadow: `var(--pcpButtonFocusedBoxShadow)`,
};

export const pcpTokensValues: PcpTokens = {
  pcpColorNeutralBackground1White: pcpGrayPalette.grey100,   // #FFFFFF, used as dialog background color
  pcpColorNeutralBackground6Dark: pcpGrayPalette.callPageBackground,   // #444A5A, used as dialog background color
  pcpColorNeutralStroke2: pcpGrayPalette.grey64,   // #96A0B4, used as border-color of input fields
  pcpColorNeutralStrokeDisabled: pcpGrayPalette.grey64, //#96A0B4, used as border-color of disabled button
  pcpColorNeutralBackground3: pcpGrayPalette.grey64, //#96A0B4, used as chat message background (and side-arrow near it)
  pcpButtonBorderRadius: '25px',
  pcpButtonFocusedBoxShadow: '0 0 0 2px #000000',
}